import React from 'react';
import card5 from '../../../assets/images/tarotcards/tarot-card-5.jpg'
import { Link } from 'react-router-dom';
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Card5 extends React.Component{
    state = {
        showOpenCookie: false
    }

    changeCookieStatus = () => {
        this.setState({showOpenCookie: !this.state.showOpenCookie})
    }

    componentDidMount() {
        sendData('', 'love tarot' , 'engaged');
    }
    
    render() {
    return (
        <div>
                <div component="p" style={{margin:'25px',color: '#e0515d', marginTop: '100px',
                                            fontSize: '45px', fontFamily: 'balthazar,serif',
                                            fontWeight: '300', letterSpacing: '.02em', textAlign: 'center'}}>
                    <FormattedMessage id="dailylove.title"
                                defaultMessage="Free Daily Love Tarot Reading"
                                />
                </div>
                <div style={{padding: '40px'}}>
                <h2 style={{fontFamily: 'khand,sans-serif',
                                fontSize: '2rem',
                                fontWeight: '100',
                                letterSpacing: '.02em',
                                textTransform: 'uppercase', textAlign: 'center'
                            }}><FormattedMessage id="t51"
                            defaultMessage="THE JUSTICE:"
                        />
                    </h2>
                        <img src={card5} style={{marginLeft: '9%', float: 'left', padding: '20px'}}/>
                        
                        <p style={{fontSize: '2rem', color: '#fefefe',
                                    fontFamily: 'balthazar,serif', marginLeft: '20%', marginRight: '20%',fontWeight: '400'}}>  
                        <br></br>
                        <FormattedMessage id="t52"
                                    defaultMessage="The Justice card serves as a reminder to make sure there is a sense of respect and decency in all of your personal relationships. Whether you're single, dating casually, newly committed, or in a long-term relationship, it's important to treat potential or current partners in a loving and decent manner, and you deserve the same in return. Coldness and bitterness have no place in your love life today."
                                />
                        <br></br><br></br>
                    </p>
                </div>
                <div style={{display: 'flex', paddingBottom: '50px'}}>
                    <span style={{width: '33%'}}>
                    </span>
                    <span style={{width: '33%'}}>
                    <Link to="/dailyLove">
                        <button style={{lineHeight: '2', letterSpacing: '0.02em'}} className={'btn btn-danger btn-lg'}><strong><FormattedMessage id="pickano"
                                defaultMessage="PICK ANOTHER CARD"
                                /></strong></button>
                    </Link>
                    </span>
                    <span style={{width: '34%'}}>
                    </span>
                </div>        
        </div>
        )
    }
}

export default Card5;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotCards/tarotCard5.js